/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EdiOutboundTrackingReason {
  InTransit = "in_transit",
  Delivered = "delivered",
  TrackingUpdate = "tracking_update",
  EtaChanged = "eta_changed",
}

export function instanceOfEdiOutboundTrackingReason(value: any): boolean {
  for (const key in EdiOutboundTrackingReason) {
    if (Object.prototype.hasOwnProperty.call(EdiOutboundTrackingReason, key)) {
      if (
        EdiOutboundTrackingReason[
          key as keyof typeof EdiOutboundTrackingReason
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EdiOutboundTrackingReasonFromJSON(
  json: any,
): EdiOutboundTrackingReason {
  return EdiOutboundTrackingReasonFromJSONTyped(json, false);
}

export function EdiOutboundTrackingReasonFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundTrackingReason {
  return json as EdiOutboundTrackingReason;
}

export function EdiOutboundTrackingReasonToJSON(
  value?: EdiOutboundTrackingReason | null,
): any {
  return value as any;
}

export function EdiOutboundTrackingReasonToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EdiOutboundTrackingReason {
  return value as EdiOutboundTrackingReason;
}
